import { API } from "aws-amplify";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  validateDni,
  validateRadio,
  validateTextOnly,
  validatorDate2,
  validatorField,
  validateDocumentByType,
  validatePepRadio,
  validateEmail,
  validateMobile,
  validatePhoneNumber,
  validatorClientText,
  validateDocumentRepLegalByType
} from "../Utils/validators";
import { typeDocumentListAsContractors, typeDocumentListAsInsured, clientsType } from '../Utils/constants';
import ErrorCustom from "./errorCustom";
import RadioButtonsSexo from "./radioButtonsSexo";
import AlertMessage from "./alertMessage";
import alert from "../Resources/img/icon-alert-yellow.png";
import RadioButtonsPep from "./RadioButtonsPep";
import Title from "./FormElements/Title";
 
function WapperGetClient({
  hasDNI,
  register,
  getValues,
  errors,
  setLoading,
  isError,
  clearError,
  setValue,
  setDps,
  defaultValue,
  setActiveNext,
  setOtherDataClient,
  clientType,
  setTerceros,
  setHasValidClientToken,
  setError,
  watch,
}) {
  const [ hasError, setHasError ] = useState(false);
  const [firstName, setfirstName] = useState("");
  const [names, setnames] = useState("");
  const [numDocumento, setnumDocumento] = useState("");
  const [lastName, setlastName] = useState("");
  const [date, setdate] = useState(null);
  const [sexo, setSexo] = useState(null);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [oportunidad, setOportunidad] = useState(null);
  const [clientExist, setclientExist] = useState(true);
  const [ maxLengthDocumentNumber, setMaxLengthDocumentNumber ] = useState(8)
  const [ maxLengthRepLegalDocumentNumber, setMaxLengthRepLegalDocumentNumber ] = useState(8);
  const [ typeDocumentList, setTypeDocumentList ] = useState([]);
  const [ isRuc, setIsRuc ] = useState(true);
  const [pep, setPep] = useState(null);
  
  const { typeDoc } = watch();
  const { typeDocReplegal } = watch();

  const [numDocumentoRepLegal, setNumDocumentoRepLegal] = useState("");
  const [dateRepLegal, setDateRepLegal] = useState(null);

  useEffect(() => {
    const showInputsForContractors = typeDoc == '4' ?  true : false ;
    setIsRuc(showInputsForContractors);
  }, [typeDoc])

  useEffect(() => {
    handleCleanFormRepLegal();
  }, [typeDocReplegal])

  const handleCleanForm = () => {
    if(typeDoc !== "3") setValue('nroDoc', '')
    setValue('names', '')
    setValue('firstName', '')
    setValue('lastName', '')
    setValue('birthday', '')
    setValue('birthday', '')
  }

  const handleCleanFormRepLegal = () => {
    setValue('nroDocReplegal', '')
    setValue('nameReplegal', '')
    setValue('lastNameFatherReplegal', '')
    setValue('lastNameMotherReplegal', '')
    setValue('fecNacimientoReplegal', '')
    setValue('sexoReplegal', '')
    setValue('responsabilityReplegal', '')
    setValue('civilStatusReplegal', '')
  }

  useEffect(() => {
    if(clientType){
      switch(clientType){
        case clientsType.CONTRACTORS:
          setTypeDocumentList([...typeDocumentListAsContractors])
          break;
        case clientsType.INSURED:
          setTypeDocumentList([...typeDocumentListAsInsured])
        default:
          setTypeDocumentList([...typeDocumentListAsInsured]);
          break;
      }
    }
  }, [clientType])

  const updateValidationOfdocumentNumber = (value) => {
    setHasError(false)
    const validationLength = typeDocumentList.find(item => item.value == value );
    setMaxLengthDocumentNumber(validationLength.min);
    setValue('nroDoc', '')
    
  }

  const updateValidationOfdocumentRepLegalNumber = (value) => {
    setHasError(false)
    const validationLength = typeDocumentList.find(item => item.value == value );
    setMaxLengthRepLegalDocumentNumber(validationLength.min);
    setValue('nroDocReplegal', '')
    
  }
  const handleChange = async (e) => {
    const { value } = e.target;
    let validatingDocument = value.toString().length >= maxLengthDocumentNumber;
    if (validatingDocument) {
      await getDataClient(value);
    }
  };

  const handleChangeRepLegal = async (e) => {
    const { value } = e.target;
    let validatingDocument = value.toString().length == maxLengthRepLegalDocumentNumber;
    if (validatingDocument) {
      await getDataClientRepLegal(value);
    } 
  };

  const getDataClient = async (value) => {
    setLoading(true);
    setnumDocumento(value);
    const typeDoc = getValues().typeDoc;

  
      const params = {
        numDocumento: value,
        tipoDocumento: typeDoc,
      };
  
      await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      }).then((dat) => {
        if (dat.status !== 200) {
          setHasError(true)
          handleCleanForm()
        } else {
          setHasError(false)
          setTerceros(dat.data.idetercero);
          setclientExist(true);
          if (typeof setOtherDataClient === "function") {
            setOtherDataClient(dat.data);
          }
          

          if(dat.data.razonSocial){
            setValue([
              { companyName: dat.data.razonSocial }
            ]);
          }else {
            setValue([
              { names: dat.data.nombres },
              { firstName: dat.data.apellidoPaterno },
              { lastName: dat.data.apellidoMaterno },
              { birthday: dat.data.fecNacimiento },
              { phone: dat.data.telefono },
              { email: dat.data.correo },
              { sexo: dat.data.sexo },
             
            ]);
            setSexo(dat.data.sexo);
            clearError([
              "firstName",
              // "lastName",
              "birthday",
              "names",
              "phone",
              "email",
              "sexo",
            ]);
          }
  
          
          
          if (defaultValue) {
            setActiveNext(true);
          }
        }
      }).catch((error) => {console.log('error.....')});
    
    

    setLoading(false);
  };

  const getDataClientRepLegal = async (value) => {
    setLoading(true);
    setNumDocumentoRepLegal(value);
    const typeDoc = getValues().typeDocReplegal;

  
      const params = {
        numDocumento: value,
        tipoDocumento: typeDoc,
      };
  
      await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      }).then((dat) => {
        if (dat.status !== 200) {
          setHasError(true)
          handleCleanFormRepLegal()
        } else {
          setHasError(false)
          setclientExist(true);
          setValue([
            { nameReplegal: dat.data.nombres },
            { lastNameFatherReplegal: dat.data.apellidoPaterno },
            { lastNameMotherReplegal: dat.data.apellidoMaterno },
            { fecNacimientoReplegal: dat.data.fecNacimiento },
            { sexoReplegal: dat.data.sexo },
            { civilStatusReplegal: dat.data.estadoCivil },
          ]);
            clearError([
              "nameReplegal",
              "lastNameFatherReplegal",
              "lastNameMotherReplegal",
              "fecNacimientoReplegal",
              "sexoReplegal",
              "civilStatusReplegal",
            ]);
        }
      }).catch((error) => {console.log('error.....')});
    
    

    setLoading(false);
  };

  const getDataClientSession = async (value) => {
    setLoading(true);

    try {
      const response = await API.get(
        "api-rentas",
        `/producto/configmin/client-by-session?tokenSesion=${value}`
      );
      setValue([
        { names: response.data.nombre },
        { firstName: response.data.apellidoPaterno },
        { lastName: response.data.apellidoMaterno },
        { birthday: moment(response.data.fechaNacimiento, "YYYY-MM-DD").format("DD/MM/YYYY") },
        { sexo: response.data.sexo },
        { nroDoc: response.data.numeroDocumento },
        { typeDoc: response.data.tipoDocumento },
        { oportunidad: response.data.idOportunidad },
        { pep: response.data.pep }
      ]);

      setOportunidad(response.data.idOportunidad);

      setclientExist(true);
      clearError(["firstName", "lastName", "birthday", "names", "sexo", "nroDoc", "oportunidad", "pep"]);
      setHasValidClientToken(true);
    } catch (error) {
      console.log({ error });
      setHasValidClientToken(false);
    }

    setLoading(false);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("sesion")) {
      getDataClientSession(params.get("sesion"));
    } else {
      if (localStorage["sesion"]) {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set("sesion", localStorage["sesion"]);

        let newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          urlParams.toString();
        getDataClientSession(localStorage["sesion"]);
        localStorage.removeItem("sesion");
        window.history.pushState({ path: newurl }, "", newurl);
      }
    }
  }, []);

  return (
    <>
      { hasError && <AlertMessage
              background="#FFEFD8"
              icono={alert}
              mensaje="Hubo un error al consultar el número de documento"
            />}
      {hasDNI && (
        <div className="vasForm__form__input-container group-input dni">
          <select className="browser-default" onChange={(value) => updateValidationOfdocumentNumber(value.target.value)} name="typeDoc" ref={register}>
            { typeDocumentList && typeDocumentList.map((el) => {
              return (<option data-object={el} value={el.value}>
              {el.name}
            </option>)
            })}
          </select>
          <div className="content">
            <input
              placeholder=" "
              name="nroDoc"
              onChange={(e) => handleChange(e)}
              ref={register({
                validate: (values) => validateDocumentByType(values, getValues),
              })}
              readOnly={oportunidad ? true : false}
              defaultValue={numDocumento}
            />
            <label htmlFor="nroDoc">Nro. documento</label>
          </div>
        </div>
      )}
      {!hasDNI && (
        <div className="content">
          <input
            placeholder=" "
            name="nroDoc"
            onChange={(e) => handleChange(e)}
            ref={register({
              validate: (values) => validateDni(values, getValues),
            })}
            readOnly={oportunidad ? true : false}
            defaultValue={numDocumento}
          />
          <label htmlFor="nroDoc">Nro. documento *</label>
        </div>
      )}
      <ErrorCustom errors={errors} name="nroDoc" />
      <div className="wapperGetClient">
          { !isRuc ? (<><div className="wapperGetClient__group">

            <div className="wapperGetClient__group__item">
              <div className="content">
                <input
                  placeholder=" "
                  name="names"
                  ref={register({
                    validate: validateTextOnly,
                  })}
                  defaultValue={names}
                  autoComplete="off"
                />
                <label htmlFor="names">Nombres</label>
              </div>
              <ErrorCustom errors={errors} name="names" />
            </div>

            <div className="wapperGetClient__group__item">
              <div className="content">
                <input
                  placeholder=" "
                  name="firstName"
                  ref={register({
                    validate: validateTextOnly,
                  })}
                  defaultValue={firstName}
                  autoComplete="off"
                />
                <label htmlFor="firstName">Apellido paterno</label>
              </div>
              <ErrorCustom errors={errors} name="firstName" />
            </div>
          </div>
          <div className="wapperGetClient__group__item">
          <div className="content">
            <input
              placeholder=" "
              name="lastName"
              ref={register({
                validate: validateTextOnly,
              })}
              defaultValue={lastName}
              autoComplete="off"
            />
            <label htmlFor="lastName">Apellido materno</label>
          </div>

          <ErrorCustom errors={errors} name="lastName" />
        </div>
        <div className="wapperGetClient__group__item">
          <div className="content">
            <input
              placeholder=" "
              name="birthday"
              format="##/##/####"
              ref={register({
                validate: (value) => validatorDate2(value, setValue, setDps),
              })}
              defaultValue={date}
              autoComplete="off"
            />
            <label htmlFor="birthday">Fecha de nacimiento</label>
          </div>
          <ErrorCustom errors={errors} name="birthday" />
        </div></>) : (<>
        
          <div className="wapperGetClient__group">

              <div className="wapperGetClient__group__item">
                <div className="content">
                  <input
                    placeholder=" "
                    name="companyName"
                    ref={register({
                      validate: validateTextOnly,
                    })}
                    defaultValue={''}
                    autoComplete="off"
                  />
                  <label htmlFor="companyName">Razón social</label>
                </div>
                <ErrorCustom errors={errors} name="companyName" />
              </div>
              <div className="wapperGetClient__group__item">
                <div className="content">
                  <input
                    placeholder=" "
                    name="giro"
                    ref={register({
                      validate: validateTextOnly,
                    })}
                    defaultValue={''}
                    autoComplete="off"
                  />
                  <label htmlFor="giro">Giro</label>
                </div>
                <ErrorCustom errors={errors} name="giro" />
              </div>
              <div className="wapperGetClient__group__item">
            <div className="content">
              <input
                placeholder=""
                name="cellphone"
                ref={register({
                  validate: {
                    required: (value) => validatePhoneNumber(value),
                  },
                })}
                maxLength="9"
                defaultValue={''}
                autoComplete="off"
              />
              <label htmlFor="cellphone">Número de teléfono</label>
            </div>
            <ErrorCustom errors={errors} name="cellphone" />
          </div>
              </div>
        </>)
        } 

          <div className="wapperGetClient__group__item">
            <div className="content">
              <input
                placeholder=""
                name="phone"
                ref={register({
                  validate: {
                    required: (value) => validateMobile(value, getValues),
                  },
                })}
                maxLength="9"
                defaultValue={phone}
                autoComplete="off"
                inputMode="numeric"
                pattern="[0-9]*"
                onChange={(e)=>{
                  e.target.value = e.target.value.replace(/\D/g, '');
                }}
              />
              <label htmlFor="phone">Número de celular</label>
            </div>
            <ErrorCustom errors={errors} name="phone" />
          </div>

          <div className="wapperGetClient__group__item">
            <div className="content">
              <input
                placeholder=""
                name="email"
                ref={register({
                  validate: {
                    required: (value) => validateEmail(value)},
                })}
                defaultValue={email}
                autoComplete="off"
              />
              <label htmlFor="email">Correo Electrónico</label>
            </div>
            <ErrorCustom errors={errors} name="email" />
          </div>

           {isRuc && (
            <>
              {/* Rep Legal */}
              <div className="form-register">
                <Title title="Datos del representante legal" />
                    <div className="vasForm">
                      <div className="vasForm__form__input-container group-input dni">
                        <select
                          className="browser-default"
                          name="typeDocReplegal"
                          onChange={(value) => updateValidationOfdocumentRepLegalNumber(value.target.value)}
                          ref={register}
                        >
                          {typeDocumentListAsInsured &&
                            typeDocumentListAsInsured.map((el) => {
                              return (
                                <option data-object={el} value={el.value} key={el.value}>
                                  {el.name}
                                </option>
                              );
                            })}
                        </select>
                        <div className="content">
                          <input
                            placeholder=" "
                            name="nroDocReplegal"
                            onChange={(e) => handleChangeRepLegal(e)}
                            defaultValue={numDocumentoRepLegal}
                            ref={register({
                              validate: (values) =>
                                validateDocumentRepLegalByType(values, getValues),
                            })}
                          />
                          <label
                            htmlFor="nroDocReplegal"
                            className={getValues().nroDocReplegal ? "active" : "false"}
                          >
                            Nro. documento
                          </label>
                        </div>
                      </div>
                      <ErrorCustom errors={errors} name="nroDocReplegal" />
                    </div>
                    <div className="clientForm__control input-field">
                      <input
                        id="nameReplegal"
                        name="nameReplegal"
                        defaultValue={""}
                        maxLength={50}
                        type="text"
                        className={errors["nameReplegal"] ? " is-error" : ""}
                        ref={register({ validate: validatorClientText })}
                      />
                      <label
                        htmlFor="nameReplegal"
                        className={getValues().nameReplegal ? "active" : "false"}
                      >
                        Nombres
                      </label>
                      <ErrorCustom errors={errors} name="nameReplegal" />
                    </div>
                    <div className="group-form input-field">
                      <div className="clientForm__control input-field">
                        <input
                          id="lastNameFatherReplegal"
                          name="lastNameFatherReplegal"
                          className={errors["lastNameFatherReplegal"] ? " is-error" : ""}
                          ref={register({ validate: validatorClientText })}
                          maxLength={50}
                          type="text"
                        />
                        <label
                          htmlFor="lastNameFatherReplegal"
                          className={getValues().lastNameFatherReplegal ? "active" : "false"}
                        >
                          Apellido paterno
                        </label>
                        <ErrorCustom errors={errors} name="lastNameFatherReplegal" />
                      </div>
                      <div className="input clientForm__control input-field">
                        <input
                          id="lastNameMotherReplegal"
                          name="lastNameMotherReplegal"
                          maxLength={100}
                          type="text"
                          className={errors["lastNameMotherReplegal"] ? " is-error" : ""}
                          ref={register}
                        />
                        <label
                          htmlFor="lastNameMotherReplegal"
                          className={getValues().lastNameMotherReplegal ? "active" : "false"}
                        >
                          Apellido materno
                        </label>
                        <ErrorCustom errors={errors} name="lastNameMotherReplegal" />
                      </div>
                    </div>
                    <div className="group-form input-field">
                    <div className="clientForm__control input-field">
                      <input
                        placeholder=" "
                        name="fecNacimientoReplegal"
                        format="##/##/####"
                        ref={register({
                          validate: (value) => validatorDate2(value, setValue, setDps),
                        })}
                        defaultValue={dateRepLegal}
                        autoComplete="off"
                      />
                      <label htmlFor="fecNacimientoReplegal" className={getValues().fecNacimientoReplegal ? "active" : "false"}>Fecha de nacimiento</label>
                      <ErrorCustom errors={errors} name="fecNacimientoReplegal" />
                      </div>
                      <div className="clientForm__control">
                        <select
                          id="sexoReplegal"
                          name="sexoReplegal"
                          ref={register({ validate: validatorField })}
                        >
                          <option value={""} disabled selected>
                            Sexo
                          </option>
                          <option value="M">Masculino</option>
                          <option value="F">Femenino</option>
                        </select>
                        <ErrorCustom errors={errors} name="sexoReplegal" />
                      </div>
                    </div>
                    <div className="group-form input-field">
                      <div className="clientForm__control input-field">
                        <input
                          id="responsabilityReplegal"
                          name="responsabilityReplegal"
                          className={errors["responsabilityReplegal"] ? " is-error" : ""}
                          ref={register({ validate: validatorClientText })}
                          maxLength={50}
                          type="text"
                        />
                        <label
                          htmlFor="responsabilityReplegal"
                        >
                          Cargo
                        </label>
                        <ErrorCustom errors={errors} name="responsabilityReplegal" />
                      </div>
                      <div className="clientForm__control">
                        <select
                          id="civilStatusReplegal"
                          name="civilStatusReplegal"
                          ref={register({ validate: validatorField })}
                        >
                          <option value={""} disabled selected>
                            Estado civil
                          </option>
                          <option value="S">Soltero</option>
                          <option value="C">Casado</option>
                          <option value="D">Divorciado</option>
                          <option value="V">Viudo</option>
                        </select>
                        <ErrorCustom errors={errors} name="civilStatusReplegal" />
                      </div>
                    </div>
              </div>      
            </>
          )}

          { !isRuc && <div className="wapperGetClient__group">
            <div className="wapperGetClient__group__item">
              <label htmlFor="" className="title_sexo">
                {" "}
                ¿Cuál es su sexo?{" "}
              </label>
              <RadioButtonsSexo
                register={register({
                  validate: (values) => validateRadio(values, getValues),
                })}
                name="sexo"
                defaultValue={sexo}
              />
              <ErrorCustom errors={errors} name="sexo" />
            </div>
            <div className="wapperGetClient__group__item">
              <label htmlFor="" className="title_sexo">
                {" "}
                Indicar si es una Persona Expuesta Políticamente (PEP){" "}
              </label>
              <RadioButtonsPep
                register={register({validate: (values) => validatePepRadio(values, getValues)})}
                name="pep"
                defaultValue={pep}
              />
              <ErrorCustom errors={errors} name="pep" />
            </div>
          </div>}


          <input
            name="oportunidad"
            defaultValue={oportunidad}
            type="hidden"
            ref={register()}
          />
        </div>

    </>
  );
}
export default WapperGetClient;
